// adapted from https://gist.github.com/francisrstokes/38256e992e48091c0f9dab5e77a40816
import { useState } from "react";

type PipedriveReactLoaderProps = {
  formId: string;
  formHeight: number;
};

const PipedriveReactLoader = ({
  formId,
  formHeight,
}: PipedriveReactLoaderProps) => {
  const [randomId] = useState("id" + Math.random().toString(36).substring(7));

  return (
    <div
      className="pipedriveWebForms"
      data-pd-webforms={`https://webforms.pipedrive.com/f/${formId}`}
      id={randomId}
    >
      <iframe
        src={`https://webforms.pipedrive.com/f/${formId}?embeded=1&uuid=${randomId}`}
        name={`${window.document.URL}-${randomId}`}
        height={"100%"}
        width={"100%"}
        style={{
          border: "none",
          overflow: "hidden",
          width: "100%",
          maxWidth: "768px",
          minWidth: "320px",
          height: `${formHeight + 16}px`,
          position: "relative",
        }}
      />
    </div>
  );
};

export default PipedriveReactLoader;
